import Vue from "vue";

import PromotionBanner from "./PromotionBanner.vue";

export function load() {
    const selector = "promotion-banner";

  // Is the custom Vue root element in the DOM?
  if (!document.querySelector(selector)) {
    return;
  }

  // Create a new Vue app with the imported Home component
  new Vue({
    render: createElement =>
      createElement(PromotionBanner, {
        props: {
          ...window[selector],
        },
      }),
  }).$mount(selector);
}
